import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { CostComparison } from './components/CostComparison';
import { Visualization } from './components/Visualization';
import { ForWhom } from './components/ForWhom';
import { HowToReceive } from './components/HowToReceive';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { EmotionalClose } from './components/EmotionalClose';
import { LegalNotice } from './components/LegalNotice';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="3ijxpcqos80jw">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-blue/85 md:text-3xl" data-id="element-1" data-mp="3ijfvu1ti80fo">
      🌿 Tu próxima consulta empieza con criterio, no con dudas.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    document.title = 'Kit Maestro de Biodescodificación™ | Recursos para Terapeutas — Latinoamérica';
    const description = 'Kit digital educativo con protocolos, fichas, preguntas de exploración y recursos visuales para terapeutas y facilitadores de Biodescodificación. 3 Tomos + 5 Bonus por US$19.';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Kit Maestro de Biodescodificación',
      content_type: 'product',
      value: 19,
      currency: 'USD'
    });
  }, []);
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-blueMist selection:text-brand-blue" data-id="element-2" data-mp="38b6yx8f1wei">
      <UrgencyBanner data-id="element-3" data-mp="d4xopd5g47cb" />
      <main data-id="element-4" data-mp="d3cwvvain2i5">
        <Hero data-id="element-5" data-mp="d3wch5cp1et0" />
        <PainPoints data-id="element-6" data-mp="d2l6cyvrzuyq" />
        <PackContents data-id="element-7" data-mp="85uj9rljzz3t" />
        <InitialTestimonials data-id="element-8" data-mp="85bc95xfyv4k" />
        <CostComparison data-id="element-9" data-mp="864djrdmssfb" />
        <Visualization data-id="element-10" data-mp="83qj9kqrzk8t" />
        <ForWhom data-id="element-11" data-mp="3gkv0fqj99ncr" />
        <HowToReceive data-id="element-12" data-mp="3gmfwxlp4rgd9" />
        <LaunchOffer data-id="element-13" data-mp="3glwabrojc3sw" />
        <MoreTestimonials data-id="element-14" data-mp="3gj1t090tiz3p" />
        <FAQ data-id="element-15" data-mp="3bmtixa1h9w3e" />
        <TransitionPhrase data-id="element-16" data-mp="3bn30c98giuxh" />
        <EmotionalClose data-id="element-17" data-mp="3bnuwpm9vowot" />
        <LegalNotice data-id="element-18" data-mp="3bkgqg2y3g3c3" />
      </main>
      <Footer data-id="element-19" data-mp="3qbpl4qgusew3" />
      <FloatingNotification data-id="element-20" data-mp="3qc95edtz7fda" />
    </div>;
}